import { Popover } from '@headlessui/react';
import { useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import useTranslation from '../../../../../hooks/useTranslations';
import { selectFolderById, selectFoldersByIds } from '../../../../../redux/modules/data/foldersSlice';
import { ArrowIcon } from '../../../../misc/icons/Icons';
import PopupWrapper from '../../../layouts/partials/PopupWrapper';

const YellowMenu = ({ activeTree }) => {
	const t = useTranslation();
	let yellowMenuItems = [];

	const baId = activeTree.businessArea.id;

	const { evaluationAppFolderId } = activeTree.businessArea;
	const { yellowMenuFolderIds } = activeTree.businessArea;
	const yellowMenuFolders = useSelector((state) => selectFoldersByIds(state, [evaluationAppFolderId, ...(yellowMenuFolderIds ?? [])]))
		.filter((item) => item);

	if (yellowMenuFolders && yellowMenuFolders.length > 0) {
		yellowMenuItems = yellowMenuFolders.map((yellowMenuFolder) => {
			const children = yellowMenuFolder.isEvaluationapp === '1'
				? yellowMenuFolder.children.slice(0, 1)
				: (yellowMenuFolder.children || []);

			return {
				folder: yellowMenuFolder,
				items: children.map((subFolderId) => (<YellowMenuItem key={subFolderId} baId={baId} folder={yellowMenuFolder} subFolderId={subFolderId} />)),
			};
		});
	}

	if (yellowMenuItems.length > 0) {
		return (
			<>
				<Popover.Group>
					{yellowMenuItems.map((yellowMenuItem, i) => (
						<PopupWrapper
							wrapperClasses="absolute left-0 lg:left-[22rem] mt-16 lg:mt-18 w-auto"
							wrapperStyles={{ top: `${56 * i}px` }}
							button={(
								<div
									className="flex items-center justify-between p-2 text-white rounded-r-full shadow-xl bg-oly-yellow-default can-hover:hover:bg-yellow-400 focus:outline-none focus-visible:bg-yellow-400"
								>
									<span className="px-6 ml-auto text-base lg:text-xl">
										{t(yellowMenuItem.folder?.translationkey ?? `btn_yellow_menu_ba_${baId}`)}
									</span>
								</div>
							)}
							items={yellowMenuItem.items}
							maxHeight="whitespace-nowrap"
							placement="bottom"
							skidding={0}
							distance={20}
						/>
					))}
				</Popover.Group>
			</>
		);
	}

	return null;
};

const YellowMenuItem = ({ baId, folder, subFolderId }) => {
	const t = useTranslation();
	const subFolder = useSelector((state) => selectFolderById(state, subFolderId));

	let url = '';
	let title = '';
	if (folder.isEvaluationapp) {
		title = folder.translationkey;
		url = `/${baId}/evaluations`;
	} else if (folder && subFolder) {
		title = subFolder.translationkey;
		url = `/${baId}/${folder.id}/${subFolder.id}`;
	}

	return (
		<NavLink
			to={url}
			className="flex items-center justify-between w-full p-2 text-left sm:p-3 can-hover:hover:bg-oly-gray-lightestAlpha45 focus-visible:bg-oly-gray-lightestAlpha45 focus:outline-none"
		>
			<span className="leading-4 sm:leading-5 text-[0.75rem] sm:text-[0.9375rem] font-semibold text-oly-gray-darkest mr-2">
				{t(title)}
			</span>
			<ArrowIcon className="flex-shrink-0 w-4 h-4 transform -rotate-90 sm:w-5 sm:h-5 text-oly-gray-default" />
		</NavLink>
	);
};

export default YellowMenu;
